import { add, format } from 'date-fns';

const simpleTime = 'h:mmaaa';

const formatTime = (dateTime: Date, timeFormat = simpleTime): string => {
  return format(dateTime, timeFormat);
};

const getClosingTime = (secondsTilClosing: number): Date => {
  const now = new Date();
  const datefnsDuration = {
    seconds: secondsTilClosing,
  };

  return add(now, datefnsDuration);
};

const getFutureTimeBySeconds = (secondsIntoFuture: number): Date => {
  const now = new Date();
  const datefnsDuration = {
    seconds: secondsIntoFuture,
  };

  return add(now, datefnsDuration);
};

export const dateTools = {
  formatTime,
  getClosingTime,
  getFutureTimeBySeconds,
};
